import { XdrSearchBaseDataProvider } from './XdrSearchBaseDataProvider';
import { XdrSearchWebComponentSchema } from '../types';

export class XdrSearchGzDataProvider extends XdrSearchBaseDataProvider {
  async getDataForView(): Promise<XdrSearchWebComponentSchema> {
    return {} as unknown as XdrSearchWebComponentSchema;
  }
}
